import React from "react";
import {Box, Heading} from "grommet";


const Avatar = ({color, initial, icon, size="medium"}) => {
    let width, height;
    switch (size) {
    case 'small':
        width = "35px";
        height = "35px";
        break;
    default:
        width = "40px";
        height = "40px";
    }
    return (
        <Box align="center">
            <Box width={{min: width, max: height}}
                height={{min: height, max: height}}
                round="50%"
                align="center"
                justify="center"
                background={{color: "active", opacity: "weak"}}
                pad='xsmall'
                border={{color: color || "border-strong", size: 'small'}}>
                {initial && initial !== '' ?
                    (<Heading
                        textAlign="center"
                        level={3}
                        size="xsmall"
                        margin="none"
                        truncate={true}
                        color={color || "border-strong"}>
                        {initial}
                    </Heading>) :
                    (icon)
                }
            </Box>
        </Box>
    );
}

export default Avatar;